/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MoveVertical = [
  "svg",
  defaultAttributes,
  [
    ["polyline", { points: "8 18 12 22 16 18" }],
    ["polyline", { points: "8 6 12 2 16 6" }],
    ["line", { x1: "12", x2: "12", y1: "2", y2: "22" }]
  ]
];

export { MoveVertical as default };
//# sourceMappingURL=move-vertical.js.map
